<template>
  <div class="grid gap-4 max-w-xl mx-auto text-center mt-12 text-slate-500">
    <p class="text-sm flex gap-2 mx-auto">
      <NuxtLink :to="{ name: 'teams' }">fans48.com</NuxtLink>
      <a href="https://tippa.se">tippa.se</a>
      <a href="https://trav.se">trav.se</a>
      <a href="https://hockeystakes.com">hockeystakes.com</a>
    </p>
    <p class="text-sm">© {{ $dayjs().format('YYYY') }} FSport AB — <a href="https://fsportgroup.com">fsportgroup.com</a></p>
    <p class="text-sm flex gap-2 mx-auto">
      <NuxtLink :to="{ name: 'legal-pp' }">Privacy Policy</NuxtLink>
      <NuxtLink :to="{ name: 'legal-toc' }">Terms & Conditions</NuxtLink>
      <button type="button" class="hover:underline" @click="openCookieSettings">{{ $t('cookieConsent.footerLink') }}</button>
    </p>
  </div>
</template>

<script setup>
const { $CookieConsent } = useNuxtApp()

const openCookieSettings = () => {
  $CookieConsent?.showPreferences()
}
</script>
